"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _path, _path2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (prefix = '') => {
  return [_path || (_path = _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9995 8c-2.2091 0-4 1.7909-4 4 0 2.2091 1.7908 4 4 4 2.2091 0 4-1.7909 4-4 0-2.2091-1.7909-4-4-4zm-2 4c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2z"
  })), _path2 || (_path2 = _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2041 12c-.191.2843-.3779.5712-.58.8478a18.5559 18.5559 0 0 1-.5547.719c-.4773.5895-1.1694 1.3776-2.0285 2.1688C17.3585 17.2851 14.87 19 11.9995 19c-2.8705 0-5.359-1.7149-7.0414-3.2644-.859-.7912-1.5512-1.5793-2.0285-2.1688a18.5293 18.5293 0 0 1-.5547-.719c-.202-.2765-.389-.5636-.58-.8478l.3748-.558c.2366-.3481.4952-.6818.7599-1.0088.4773-.5895 1.1694-1.3776 2.0285-2.1688C6.6405 6.715 9.129 5 11.9995 5c2.8705 0 5.359 1.715 7.0414 3.2644.8591.7912 1.5512 1.5793 2.0285 2.1688.2393.2956.4262.5432.5547.719.202.2765.3891.5635.58.8478zM4.2399 12c.4213-.5445 1.1436-1.4084 2.073-2.2644C7.888 8.285 9.8995 7 11.9996 7c2.1001 0 4.1116 1.285 5.6865 2.7356.9295.8561 1.6518 1.7199 2.0731 2.2644-.4213.5445-1.1436 1.4083-2.0731 2.2644C16.1111 15.7149 14.0996 17 11.9995 17c-2.1 0-4.1116-1.2851-5.6865-2.7356-.9295-.8561-1.6518-1.7199-2.0731-2.2644z"
  }))];
};

exports.default = _default;